
"use client"

const AppBarMenu = ({ title, menuItems=[] }) => {

  return (
    <div className="px-4 w-full absolute">
      <div className="py-8 px-6 bg-white rounded-lg shadow-md min-h-full w-full ">
        <h2 className="text-xl font-semibold mb-6 text-gray-700">{title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {menuItems && menuItems?.map((menuItem, index) => (
            <a
              key={index}
              className="flex items-center p-4 rounded-lg hover:bg-gray-50 transition-shadow cursor-pointer"
               href={"/"+menuItem.link}
            >
              <div className="flex-shrink-0 text-2xl w-[70px] aspect-square">
                {menuItem.icon}
              </div>
              <div className="ml-4 w-full">
                <h3 className="text-lg font-semibold text-gray-800 whitespace-normal">
                  {menuItem.title}
                </h3>
                <p className="text-sm text-gray-600 ">
                  {menuItem.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppBarMenu;
